export class DeviceParamGatewayV3CronPostLirisFileFromGateway {
    public every: string = '1h';
    public enable: number = 0;
}
